module.exports = __webpack_public_path__ + "static/media/drumroll.4daaafd7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/drumroll.mp3
// module id = 1650
// module chunks = 0